// src/context/EnvironmentContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentEnvironment, switchEnvironment } from '../config/environment';

const EnvironmentContext = createContext();

export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
};

export const EnvironmentProvider = ({ children }) => {
  const [currentEnv, setCurrentEnv] = useState(getCurrentEnvironment());
  const [isLoading, setIsLoading] = useState(false);

  const changeEnvironment = async (newEnv) => {
    if (newEnv === 'PROD' || newEnv === 'PREPROD') {
      setIsLoading(true);
      
      // Cambiar el ambiente
      const success = switchEnvironment(newEnv);
      
      if (success) {
        // Actualizar el estado
        setCurrentEnv(getCurrentEnvironment());
        
        // Mostrar mensaje de éxito
        console.log(`Ambiente cambiado a: ${newEnv}`);
        
        // No recargar la página, solo actualizar el estado
        setIsLoading(false);
        return true;
      }
      
      setIsLoading(false);
      return false;
    }
    return false;
  };

  const refreshEnvironment = () => {
    setCurrentEnv(getCurrentEnvironment());
  };

  return (
    <EnvironmentContext.Provider
      value={{
        currentEnv,
        changeEnvironment,
        refreshEnvironment,
        isLoading
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};